/// \file fleetActivity.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const FleetactivityList = lazy(() => import('../views/fleet-activity/list/view'));

async function fleetactivityDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/fleet-activity/list/loader')).default;
  return actualLoader(args);
}

export async function fleetactivityAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/fleet-activity/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="activity"
    handle={{
      text:"ACTIVITY"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <FleetactivityList />
        </Suspense>
      }
      loader={fleetactivityDataLoader}
      action={fleetactivityAction}
      />
  </Route>
);

export default routes;